var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "activitiesFilter", staticClass: "page" },
    [
      _c("div", { staticClass: "container-fluid mb-32 mb-lg-40" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "filter-row" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 position-relative d-flex flex-row mt-8 align-self-center"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "mr-8 mr-md-24",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.show_filters = !_vm.show_filters
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter-button d-flex align-items-center tag tag-sm mb-8"
                          },
                          [
                            _c("i", {
                              staticClass: "mr-8 filter-icon",
                              domProps: { innerHTML: _vm._s(_vm.svg("filter")) }
                            }),
                            _c(
                              "small",
                              {
                                staticClass:
                                  "d-none d-md-block text-accent font-weight-light"
                              },
                              [_vm._v("Filter")]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tag-row align-items-center" },
                      [
                        _vm.searchText
                          ? _c("div", { staticClass: "tag-col d-flex" }, [
                              _c("a", {
                                staticClass: "tag tag-accent tag-sm mb-8",
                                domProps: {
                                  innerHTML: _vm._s("“" + _vm.searchText + "”")
                                },
                                on: { click: _vm.clearSearchText }
                              })
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.selectedCategories, function(category) {
                          return _c(
                            "div",
                            { key: category.id, staticClass: "tag-col d-flex" },
                            [
                              _c("a", {
                                staticClass: "tag tag-accent tag-sm mb-8",
                                domProps: { innerHTML: _vm._s(category.name) },
                                on: {
                                  click: function($event) {
                                    return _vm.toggleAndFilterCategory(category)
                                  }
                                }
                              })
                            ]
                          )
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("filter-menu", {
                      attrs: {
                        "grouped-categories": _vm.groupedCategories,
                        show: _vm.show_filters
                      },
                      on: {
                        input: function() {
                          return _vm.filterActivities()
                        },
                        close: function($event) {
                          _vm.show_filters = false
                        }
                      },
                      model: {
                        value: _vm.selectedCategories,
                        callback: function($$v) {
                          _vm.selectedCategories = $$v
                        },
                        expression: "selectedCategories"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      !(_vm.filteredActivities || _vm.activities).length
        ? [
            _c("ask-banner-row", {
              staticClass: "mb-80 mb-xxl-120",
              attrs: {
                src: _vm.noResultsConfig.image.sizes.large,
                title: _vm.noResultsConfig.title,
                description: _vm.noResultsConfig.description,
                phone: _vm.noResultsConfig.phone,
                email: _vm.noResultsConfig.email,
                cta: _vm.noResultsConfig.cta,
                "cta-link": _vm.noResultsConfig.cta_link
              }
            }),
            _vm._v(" "),
            _vm._m(0)
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("activities-row", {
        attrs: {
          activities: _vm.shownActivities,
          ratio: _vm.ratio,
          "force-grid": true,
          "items-per-row": 6
        }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("h3", { staticClass: "mb-32" }, [
            _vm._v("Misschien is dit iets voor jou!")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }